{
  "TEAMS_SETTINGS": {
    "NEW_TEAM": "Vytvoriť nový tím",
    "HEADER": "Tímy",
    "LOADING": "Načítavajú sa tímy",
    "DESCRIPTION": "Tímy vám umožňujú organizovať agentov do skupín podľa ich zodpovedností. Agent môže patriť do viacerých tímov. Pri spolupráci môžete priraďovať konverzácie konkrétnym tímom.",
    "LEARN_MORE": "Zistiť viac o tímoch",
    "LIST": {
      "404": "Na tomto účte nie sú vytvorené žiadne tímy.",
      "EDIT_TEAM": "Upraviť tím",
      "NONE": "Žiadne"
    },
    "CREATE_FLOW": {
      "CREATE": {
        "TITLE": "Vytvoriť nový tím",
        "DESC": "Pridajte názov a popis k vášmu novému tímu."
      },
      "AGENTS": {
        "BUTTON_TEXT": "Pridať agentov do tímu",
        "TITLE": "Pridať agentov do tímu - {teamName}",
        "DESC": "Pridajte agentov do vášho novovytvoreného tímu. To vám umožní spolupracovať ako tím na konverzáciách a dostávať upozornenia na nové udalosti v tej istej konverzácii."
      },
      "WIZARD_CREATE": {
        "TITLE": "Vytvoriť",
        "BODY": "Vytvorte nový tím agentov."
      },
      "WIZARD_ADD_AGENTS": {
        "TITLE": "Pridať agentov",
        "BODY": "Pridať agentov do tímu."
      },
      "WIZARD_FINISH": {
        "TITLE": "Hotovo",
        "BODY": "Všetko je pripravené!"
      }
    },
    "EDIT_FLOW": {
      "CREATE": {
        "TITLE": "Upravte údaje o svojom tíme",
        "DESC": "Upravte názov a popis svojho tímu.",
        "BUTTON_TEXT": "Aktualizovať tím"
      },
      "AGENTS": {
        "BUTTON_TEXT": "Aktualizovať agentov v tíme",
        "TITLE": "Pridať agentov do tímu - {teamName}",
        "DESC": "Pridajte agentov do novovytvoreného tímu. Všetci pridaní agenti budú upozornení, keď sa do tohto tímu priradí konverzácia."
      },
      "EDIT_WIZARD_DETAILS": {
        "TITLE": "Tímové detaily",
        "ROUTE": "Upraviť tímové detaily",
        "BODY": "Zmena názvu, popisu a ďalších údajov."
      },
      "EDIT_WIZARD_AGENTS": {
        "TITLE": "Upraviť agentov",
        "ROUTE": "settings_teams_edit_members",
        "BODY": "Upravte agentov vo svojom tíme."
      },
      "EDIT_WIZARD_FINISH": {
        "TITLE": "Hotovo",
        "ROUTE": "settings_teams_edit_finish",
        "BODY": "Všetko je pripravené!"
      }
    },
    "TEAM_FORM": {
      "ERROR_MESSAGE": "Nepodarilo sa uložiť údaje o tíme. Skúste to znova."
    },
    "AGENTS": {
      "AGENT": "AGENT",
      "EMAIL": "EMAIL",
      "BUTTON_TEXT": "Pridať agentov",
      "ADD_AGENTS": "Pridávajú sa agenti do tímu...",
      "SELECT": "vybrať",
      "SELECT_ALL": "vybrať všetkých agentov",
      "SELECTED_COUNT": "{selected} z {total} vybraných agentov."
    },
    "ADD": {
      "TITLE": "Pridať agentov do tímu - {teamName}",
      "DESC": "Pridajte agentov do novovytvoreného tímu. To vám umožní spolupracovať v tíme na konverzáciách a dostávať upozornenia na nové udalosti v tej istej konverzácii.",
      "SELECT": "vybrať",
      "SELECT_ALL": "vybrať všetkých agentov",
      "SELECTED_COUNT": "{selected} z {total} vybraných agentov.",
      "BUTTON_TEXT": "Pridať agentov",
      "AGENT_VALIDATION_ERROR": "Vyberte aspoň jedného agenta."
    },
    "FINISH": {
      "TITLE": "Váš tím je pripravený!",
      "MESSAGE": "Na konverzáciách teraz môžete spolupracovať ako tím. Šťastná podpora ",
      "BUTTON_TEXT": "Hotovo"
    },
    "DELETE": {
      "BUTTON_TEXT": "Vymazať",
      "API": {
        "SUCCESS_MESSAGE": "Tím úspešne odstránený.",
        "ERROR_MESSAGE": "Tím sa nepodarilo vymazať! Skúste to znova."
      },
      "CONFIRM": {
        "TITLE": "Naozaj chcete odstrániť tento tím?",
        "PLACE_HOLDER": "Pre potvrdenie zadajte {teamName}",
        "MESSAGE": "Odstránením tímu sa odstráni priradenie tímu z konverzácií priradených k tomuto tímu.",
        "YES": "Vymazať ",
        "NO": "Zrušiť"
      }
    },
    "SETTINGS": "Nastavenia",
    "FORM": {
      "UPDATE": "Aktualizovať tím",
      "CREATE": "Vytvoriť tím",
      "NAME": {
        "LABEL": "Názov tímu",
        "PLACEHOLDER": "Príklad: Predaj, zákaznícka podpora"
      },
      "DESCRIPTION": {
        "LABEL": "Popis tímu",
        "PLACEHOLDER": "Krátky popis tohto tímu."
      },
      "AUTO_ASSIGN": {
        "LABEL": "Povoliť automatické priradenie pre tento tím."
      },
      "SUBMIT_CREATE": "Vytvoriť tím"
    }
  }
}
